import { useMemo, ReactNode } from 'react';
import { ErrorBoundary as ShellErrorBoundary } from '~/components/Tools';
import { APP_NAME, STREAM_NAME, PROJECT_TYPE } from '../../config/constants';

interface ErrorBoundaryWrapperHeaderProps {
  children: ReactNode;
  config?: Record<string, any>;
  [key: string]: any; // For rest props
}

export default function ErrorBoundaryWrapperHeader({
  children,
  config: propConfig,
  ...rest
}: ErrorBoundaryWrapperHeaderProps) {
  const config = useMemo(
    () => ({
      stream: STREAM_NAME,
      projectType: PROJECT_TYPE,
      appName: APP_NAME,
      pageName: APP_NAME,
      location: window.location.href,
      errorCapturedInShellErrorBoundary: false,
      ...(propConfig || {}),
    }),
    [propConfig]
  );

  return (
    <ShellErrorBoundary config={config} {...rest}>
      {children}
    </ShellErrorBoundary>
  );
}
